import { WebsocketParams } from "./websocket-params";

export class ModeratorWebsocketParams implements Pick<WebsocketParams, 'memberType' | 'memberDisplayName' | 'displayId' | 'token'> {
  memberType: Required<WebsocketParams>['memberType'];
  memberDisplayName: Required<WebsocketParams>['memberDisplayName'];
  displayId: Required<WebsocketParams>['displayId'];
  token: Required<WebsocketParams>['token'];

  constructor(memberDisplayName: ModeratorWebsocketParams['memberDisplayName'], displayId: ModeratorWebsocketParams['displayId'], token: ModeratorWebsocketParams['token']) {
    this.memberType = 'moderator';
    this.memberDisplayName = memberDisplayName;
    this.displayId = displayId;
    this.token = token;
  }

  asQueryParams() {
    const params = new URLSearchParams();
    params.append('memberType', this.memberType);
    params.append('memberDisplayName', this.memberDisplayName);
    params.append('displayId', this.displayId);
    params.append('token',  `Bearer ${this.token}`);
    return params.toString();
  }

  isModerator() {
    return true;
  }
}
